import { type ChangeEvent, useRef } from 'react'

import style from './FilePicker.module.scss'

interface IProps {
    title: string
    className: string
    isAddedAttach: boolean
    disabled?: boolean
    onHandleFile: (uploadedFile: File, isAddedAttach: boolean) => void
}

export const FilePicker = (props: IProps) => {
    const { disabled, title, className, isAddedAttach, onHandleFile } = props

    const hiddenFileInput = useRef<HTMLInputElement | null>(null)

    const onTitleClick = () => {
        if (disabled) return
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const onHandleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (disabled) return
        event.preventDefault()
        if (!event.target.files) {
            return
        }

        const fileUploaded = event.target.files[0]
        onHandleFile(fileUploaded, isAddedAttach)

        if (hiddenFileInput.current) {
            hiddenFileInput.current.value = ''
        }
    }

    return (
        <>
            <span className={className} onClick={onTitleClick}>
                {title}
            </span>
            <div className={style.container}>
                <input type='file' ref={hiddenFileInput} onChange={onHandleChange} />
            </div>
        </>
    )
}
